<template>
    <div :class="statusBoxClass">
        <!-- This image is shown if the Phone is either online or offline, but there is no past or present call to display. -->
        <div class="icon" v-if="headsetIcon">
            <img src="/traveller-ui/static/traveller/img/headset.png" alt="headset"/>
        </div>
        <div>
            <div class="recipient">{{ recipientText }}
                <span id="group-call-list-button" v-if="isGroupCall && false" @click="toggleGroupCallStatus"><b-icon icon="list" scale="1" /></span>
            </div>
            <div :class="statusClass">{{ statusText }}</div>
        </div>
        <GroupCallStatus :visible="groupCallStatus" @close="groupCallStatus=false"/>

        <div id="group-call-list-tab" v-if="isGroupCall && !groupCallStatus" @click="toggleGroupCallStatus">
            <b-icon icon="chevron-double-right"/>
        </div>
    </div>
</template>

<script>
import phone from '@/store/dispatching/phone';
import moment from "moment";

import GroupCallStatus from '@/components/Dispatching/VoIP/GroupCallStatus.vue';

export default {
    name: 'PhoneStatus',
    components: { GroupCallStatus },
    data: function() {
        return {
            headsetIcon: true,
            groupCallStatus: false, // = GroupCallStatus component visible or not.
            statusClass: 'status error',
            callDuration: '',
            durationCalculator: null
        };
    },
    beforeCreate: function() {
        if (!this.$store.state.phone) {
            this.$store.registerModule('phone', phone);
        }
    },
    computed: {
        statusBoxClass() {
            let statusBoxClass = 'status-box';
            if (!this.headsetIcon) {
                statusBoxClass += ' narrow';
            }
            return statusBoxClass;
        },
        recipientText() {
            let recipient = '';
            switch (this.$store.state.phone.phoneState.status) {
                case 'connected':
                case 'registered':
                case 'disconnected':
                case 'unregistered':
                case 'unconfigured':
                    recipient = this.$t('voip.phone.voice_services')
                    break;
                case 'group_call_setup':
                    recipient = this.$t('voip.phone.group_call');
                    break;
                case 'calling':
                case 'call_connected':
                case 'call_ended':
                case 'call_error':
                    if (this.$store.state.phone.phoneState.isGroupCall) {
                        recipient = this.$t('voip.phone.group_call');
                    } else {
                        // For individual calls, display vehicle number.
                        let r = this.$store.state.phone.phoneState.recipient;
                        if (r && this.$store.state.phone.reversePhonebook[r]) {
                            recipient = this.$t('voip.phone.vehicle') +': '+ this.$store.state.phone.reversePhonebook[r];
                        }
                    }
            }
            return recipient;
        },
        statusText() {
            let status = '';
            switch (this.$store.state.phone.phoneState.status) {
                case 'connected':
                case 'registered':
                    status = this.$t('voip.phone.connected');
                    break;
                case 'disconnected':
                case 'unregistered':
                    status = this.$t('voip.phone.no_connection');
                    break;
                case 'unconfigured':
                    status = this.$t('voip.phone.unconfigured');
                    break;
                case 'group_call_setup':
                    break;
                case 'calling':
                    status = this.$t('voip.phone.connecting');
                    break;
                case 'call_connected':
                    status = this.$t('voip.phone.call_connected');
                    if (this.callDuration) {
                        status += ' - '+ this.callDuration;
                    }
                    break;
                case 'call_ended':
                    status = this.$t('voip.phone.call_ended');
                    break;
                case 'call_error':
                    status = this.$t('voip.phone.error_detected');
            }
            return status;
        },
        phoneStatus() {
            return this.$store.state.phone.phoneState.status;
        },
        isGroupCall() {
            return this.$store.state.phone.phoneState.isGroupCall
        }
    },
    watch: {
        phoneStatus(s) {
            clearTimeout(this.durationCalculator);
            this.callDuration = '';

            switch (s) {
                case 'connected':
                case 'registered':
                    this.headsetIcon = true;
                    this.statusClass = 'status ok';
                    break;
                case 'disconnected':
                case 'unregistered':
                case 'unconfigured':
                    this.headsetIcon = true;
                    this.statusClass = 'status error';
                    break;
                case 'call_connected':
                    this.calculateCallDuration();
                    this.headsetIcon = false;
                    this.statusClass = 'status';
                    break;
                case 'group_call_setup':
                case 'calling':
                case 'call_ended':
                    this.headsetIcon = false;
                    this.statusClass = 'status';
                    break;
                case 'call_error':
                    this.headsetIcon = false;
                    this.statusClass = 'status error';
            }
        },
        // This watcher operates such that when the state of "isGroupCall" changes,
        // the participant list box either appears or disappears.
        isGroupCall(gc) {
            this.groupCallStatus = gc;
        }
    },
    methods: {
        toggleGroupCallStatus() {
            this.groupCallStatus = !this.groupCallStatus;
        },
        calculateCallDuration() {
            clearTimeout(this.durationCalculator);

            let callDuration = '';
            if (this.$store.state.phone.phoneState.callStartTime) {
                let duration = moment.duration(new moment().diff(this.$store.state.phone.phoneState.callStartTime));
                if (duration.get('minutes') >= 60) {
                    callDuration = moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
                } else {
                    callDuration = moment.utc(duration.asMilliseconds()).format('mm:ss');
                }
            }
            this.callDuration = callDuration;

            this.durationCalculator = setTimeout(this.calculateCallDuration, 1000);
        },
        //TODO: Remove
        testIndividualCall(recipient) {
            if (this.phoneStatus == 'calling' || this.phoneStatus == 'call_connected') {
                this.$store.commit('phone/requestEndCall');
            } else {
                this.$store.commit('phone/requestIndividualCall', recipient);
            }
        },
        //TODO: Remove
        testGroupCall(recipient) {
            if (this.phoneStatus == 'calling' || this.phoneStatus == 'call_connected') {
                this.$store.commit('phone/requestEndCall');
            } else {
                for( const sipClientId of recipient ) {
                    this.$store.commit('phone/addGroupCallRecipient' , sipClientId)
                }
                this.$store.commit('phone/requestGroupCall', recipient);
            }
        }
    }
}
</script>